<ng-container *ngTemplateOutlet="currentTemplate; context: context"></ng-container>

<ng-template #template_default let-title="title">
    <div style="page-break-inside: avoid">
        <h5>{{title}}</h5>
        <table class="optionalComponentSectionTable">
            <tr style="font-weight: bold;">
                <td>Technology Type</td>
                <td>{{ccsTechnology.type}}</td>
                <td rowspan="4" style="vertical-align: top;">
                    <b>Structures:</b><br />
                    <table>
                        <tr>
                            <td>Structure Type</td>
                            <td>Capacity</td>
                            <td>Injection Rate</td>
                        </tr>
                        <tr *ngFor="let ccsStructure of ccsTechnology.ccsStorageStructures">
                            <td [innerHTML]="ccsStructure.type | highlight: searchTerm"></td>
                            <td *ngIf="ccsStructure.capacity">{{ccsStructure.capacity}}</td>
                            <td *ngIf="ccsStructure.injectionRate">{{ccsStructure.injectionRate}}</td>
                        </tr>
                    </table>
                </td>
            </tr>
            <tr>
                <td style="font-weight: bold;">Technology Subtype</td>
                <td [innerHTML]="ccsTechnology.subType | highlight: searchTerm"></td>
            </tr>
            <tr *ngIf="ccsTechnology.hasPipeline || ccsTechnology.hasTanker">
                <td style="font-weight: bold;">Includes</td>
                <td>
                    <span *ngIf="ccsTechnology.hasPipeline">Pipeline</span>
                    <span *ngIf="ccsTechnology.hasPipeline && ccsTechnology.hasTanker"> & </span>
                    <span *ngIf="ccsTechnology.hasTanker">Tanker</span>
                </td>
            </tr>
            <tr>
                <td colspan="2"></td>
            </tr>
        </table>
    </div>
</ng-template>

<ng-template #template_mobile let-title="title">
    <div style="page-break-inside: avoid">
        <h5>{{title}}</h5>
        <table class="optionalComponentSectionTable">
            <tr style="font-weight: bold;">
                <td>Technology Type</td>
                <td>{{ccsTechnology.type}}</td>
            </tr>
            <tr>
                <td style="font-weight: bold;">Technology Subtype</td>
                <td [innerHTML]="ccsTechnology.subType | highlight: searchTerm"></td>
            </tr>
            <tr *ngIf="ccsTechnology.hasPipeline || ccsTechnology.hasTanker">
                <td style="font-weight: bold;">Includes</td>
                <td>
                    <span *ngIf="ccsTechnology.hasPipeline">Pipeline</span>
                    <span *ngIf="ccsTechnology.hasPipeline && ccsTechnology.hasTanker"> & </span>
                    <span *ngIf="ccsTechnology.hasTanker">Tanker</span>
                </td>
            </tr>
            <tr>
                <td colspan="2"></td>
            </tr>
            <tr>
                <td style="font-weight: bold;">Structures</td>
                <td>
                    <table>
                        <tr>
                            <td>Structure Type</td>
                            <td>Capacity</td>
                            <td>Injection Rate</td>
                        </tr>
                        <tr *ngFor="let ccsStructure of ccsTechnology.ccsStorageStructures">
                            <td [innerHTML]="ccsStructure.type | highlight: searchTerm"></td>
                            <td *ngIf="ccsStructure.capacity">{{ccsStructure.capacity}}</td>
                            <td *ngIf="ccsStructure.injectionRate">{{ccsStructure.injectionRate}}</td>
                        </tr>
                    </table>
                </td>
            </tr>
        </table>
    </div>
</ng-template>